import React, { useEffect } from "react";
import { Drawer, Form, Input, Button, Switch } from "antd";

const CreateZone = ({ open, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      if (initialValues) {
        form.setFieldsValue({
          ...initialValues,
          is_active:
            initialValues.is_active === 1 ||
            initialValues.is_active === true,
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          is_active: true,
        });
      }
    }
  }, [initialValues, open, form]);

  const handleFinish = (values) => {
    const formattedValues = {
      ...values,
      is_active: values.is_active ? 1 : 0,
    };

    onSubmit(formattedValues);
  };

  return (
    <Drawer
      title={initialValues ? "Edit Zone" : "Create Zone"}
      width={420}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        onValuesChange={(changedValues) => {
          if (changedValues.name !== undefined) {
            form.setFieldsValue({
              code: changedValues.name
                ?.toLowerCase()
                .trim()
                .replace(/\s+/g, "_"),
            });
          }
        }}
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>{initialValues ? "Update Zone Details" : "Create Zone Details"}</h3>
              <p>Fill the details below to save the zone.</p>
            </div>
          </div>

          <Form.Item
            label="Zone Name"
            name="name"
            rules={[{ required: true, message: "Please enter zone name" }]}
          >
            <Input placeholder="Enter zone name" />
          </Form.Item>

          <Form.Item
            label="Status"
            name="is_active"
            valuePropName="checked"
          >
            <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
          </Form.Item>

          <div className="form-actions">
            <Button className="secondary-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="primary-btn">
              {initialValues ? "Update Zone" : "Save Zone"}
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateZone;